import { Box, Checkbox, List, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAtom, useAtomValue } from 'jotai';
import { Business_Profile_Enum } from '@kheops/graphql';
import SearchInput from '../../common/components/SearchInput';
import SelectFilterChip from '../../common/components/SelectFilterChip';
import { arrayToggle } from '../../common/utils/common.utils';
import { signedContractsAtom, currentContextAtom } from '../../state';
import { OrderListUiState, orderListUiStateAtom } from '../state/state';

export default function OrderCompanyFilter(): React.JSX.Element {
  const { t } = useTranslation(['common']);
  const { realm } = useAtomValue(currentContextAtom);
  const contracts = useAtomValue(signedContractsAtom);
  const [orderListUiState, setOrderListUiState] = useAtom(orderListUiStateAtom);
  const [query, setQuery] = useState('');

  const handleSelectedCompanyChange = (companyId: string): void => {
    const newSelectedCompanyIds = [...orderListUiState.selectedCompanyIds];

    arrayToggle(newSelectedCompanyIds, companyId);

    const newState: OrderListUiState = {
      ...orderListUiState,
      selectedCompanyIds: newSelectedCompanyIds,
    };

    setOrderListUiState(newState);

    window.history.replaceState({
      ...window.history.state,
      uiState: {
        ...newState,
        page: 1,
      },
    }, '');
  };

  const filteredCompanies = useMemo(
    () => contracts.filter(({ company }) => company.tradeName.toLowerCase().includes(query.toLowerCase())),
    [query, contracts],
  );

  return (
    <SelectFilterChip
      isFilterActive={!!orderListUiState.selectedCompanyIds.length}
      label={`${realm === Business_Profile_Enum.Supplier ? t('common:customer_other') : t('common:supplier_other')} (${orderListUiState.selectedCompanyIds.length || contracts.length})`}
      content={(
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <SearchInput
            fullWidth
            value={query}
            onChange={setQuery}
            placeholder={t('common:search')}
          />
          <Typography sx={{ mt: 2, mb: 1 }} variant="titleMedium">{realm === Business_Profile_Enum.Supplier ? t('search:select_one_or_several_clients') : t('search:select_one_or_several_suppliers')}</Typography>
          <List>
            {filteredCompanies.map(({ company }) => (
              <ListItemButton
                key={company.id}
                onClick={() => handleSelectedCompanyChange(company.id)}
              >
                <ListItemText primary={company.tradeName} />
                <ListItemIcon>
                  <Checkbox
                    edge="start"
                    checked={orderListUiState.selectedCompanyIds.includes(company.id)}
                  />
                </ListItemIcon>
              </ListItemButton>
            ))}
          </List>
        </Box>
      )}
      onClose={() => setQuery('')}
    />
  );
}
